var map = {
	"./buildings.png": "./src/assets/icons/menu/buildings.png",
	"./dashboard.png": "./src/assets/icons/menu/dashboard.png",
	"./dashboard/icon@2x.png": "./src/assets/icons/menu/dashboard/icon@2x.png",
	"./dashboard/icon@3x.png": "./src/assets/icons/menu/dashboard/icon@3x.png",
	"./hydrogen.png": "./src/assets/icons/menu/hydrogen.png",
	"./hydrogen.svg": "./src/assets/icons/menu/hydrogen.svg",
	"./hydrogen/icon@2x.png": "./src/assets/icons/menu/hydrogen/icon@2x.png",
	"./hydrogen/icon@3x.png": "./src/assets/icons/menu/hydrogen/icon@3x.png",
	"./media_consumo.svg": "./src/assets/icons/menu/media_consumo.svg",
	"./meteorology.svg": "./src/assets/icons/menu/meteorology.svg",
	"./mobility.png": "./src/assets/icons/menu/mobility.png",
	"./mobility/icon@2x.png": "./src/assets/icons/menu/mobility/icon@2x.png",
	"./mobility/icon@3x.png": "./src/assets/icons/menu/mobility/icon@3x.png",
	"./mobilityEletric.png": "./src/assets/icons/menu/mobilityEletric.png",
	"./mobilityEletric/icon@2x.png": "./src/assets/icons/menu/mobilityEletric/icon@2x.png",
	"./mobilityEletric/icon@3x.png": "./src/assets/icons/menu/mobilityEletric/icon@3x.png",
	"./occurrence.png": "./src/assets/icons/menu/occurrence.png",
	"./occurrence/icon@2x.png": "./src/assets/icons/menu/occurrence/icon@2x.png",
	"./occurrence/icon@3x.png": "./src/assets/icons/menu/occurrence/icon@3x.png",
	"./parking.png": "./src/assets/icons/menu/parking.png",
	"./parking/icon@2x.png": "./src/assets/icons/menu/parking/icon@2x.png",
	"./parking/icon@3x.png": "./src/assets/icons/menu/parking/icon@3x.png",
	"./pattern.svg": "./src/assets/icons/menu/pattern.svg",
	"./population_data.svg": "./src/assets/icons/menu/population_data.svg",
	"./streetLighting.png": "./src/assets/icons/menu/streetLighting.png",
	"./streetLighting/icon@2x.png": "./src/assets/icons/menu/streetLighting/icon@2x.png",
	"./streetLighting/icon@3x.png": "./src/assets/icons/menu/streetLighting/icon@3x.png",
	"./video.png": "./src/assets/icons/menu/video.png",
	"./wasteFleet.png": "./src/assets/icons/menu/wasteFleet.png",
	"./wasteFleet/icon@2x.png": "./src/assets/icons/menu/wasteFleet/icon@2x.png",
	"./wasteFleet/icon@3x.png": "./src/assets/icons/menu/wasteFleet/icon@3x.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons/menu sync recursive ^\\.\\/.*$";